exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SuspenseEnvironmentDefault___2j3Vk {\n  --color-suspense: var(--color-suspense-default);\n  --color-transition: var(--color-transition-default);\n}\n\n.SuspenseEnvironmentServer___1NIaq {\n  --color-suspense: var(--color-suspense-server);\n  --color-transition: var(--color-transition-server);\n}\n\n.SuspenseEnvironmentOther___HawwP {\n  --color-suspense: var(--color-suspense-other);\n  --color-transition: var(--color-transition-other);\n}\n", ""]);

// exports
exports.locals = {
	"SuspenseEnvironmentDefault": "SuspenseEnvironmentDefault___2j3Vk",
	"SuspenseEnvironmentServer": "SuspenseEnvironmentServer___1NIaq",
	"SuspenseEnvironmentOther": "SuspenseEnvironmentOther___HawwP"
};